import { Turbo } from "@hotwired/turbo-rails";
import DOMPurify from "dompurify";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["button", "errorContainer", "onboardingSteps"];
  static values = {
    url: String,
  };

  connect() {
    this.isSubmitting = false;
  }

  install(event) {
    event.preventDefault();

    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.disableButton();
    this.clearError();

    fetch(this.urlValue, {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
      credentials: "same-origin",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success && data.redirect_url) {
          Turbo.visit(data.redirect_url);
        } else if (data.success) {
          Turbo.visit("/merch_stores");
        } else {
          this.showError(data.error);
          this.isSubmitting = false;
          this.buttonTarget.textContent = this.buttonTarget.dataset.textContent;
        }
      })
      .catch(() => {
        this.showError(data.error);
        this.isSubmitting = false;
        this.buttonTarget.textContent = this.buttonTarget.dataset.textContent;
      });
  }

  disableButton() {
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("disabled", "disabled");
      this.buttonTarget.dataset.textContent = this.buttonTarget.textContent;
      this.buttonTarget.textContent = "Processing...";
    }
  }

  showError(error) {
    if (this.hasOnboardingStepsTarget) {
      this.onboardingStepsTarget.classList.add("display-none");
    }

    if (this.hasErrorContainerTarget) {
      this.errorContainerTarget.innerHTML = `
        <div class="margin-top-20 text-red-700">
          <i class="fa fa-exclamation-circle"></i>
          <span>${DOMPurify.sanitize(error)}</span>
        </div>
      `;
      this.errorContainerTarget.classList.remove("display-none");
    }
  }

  clearError() {
    if (this.hasErrorContainerTarget) {
      this.errorContainerTarget.innerHTML = "";
      this.errorContainerTarget.classList.add("display-none");
    }
  }
}
